import { createFileRoute } from "@tanstack/react-router";
import { Kalkulator } from "@/pages/team/Kalkulator";

/** Eine gespeicherte Kalkulation öffnen (Angebotsrechner, 21.09.2026). */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/kalkulator_/$kalkulationId")({
	component: KalkulationSeite,
});

function KalkulationSeite() {
	const { kalkulationId } = Route.useParams();
	return <Kalkulator kalkulationId={kalkulationId} />;
}
